import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './AdminTables.css';

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    Promise.all([
      fetch(getApiUrl('/api/admin/payments'), { headers: { Authorization: `Bearer ${token}` } }),
      fetch(getApiUrl('/api/admin/payments/summary'), { headers: { Authorization: `Bearer ${token}` } }),
    ])
      .then(([r1, r2]) => Promise.all([r1.json(), r2.json()]))
      .then(([j1, j2]) => {
        if (j1.success) setPayments(j1.payments || []);
        if (j2.success) setSummary(j2.summary);
        if (!j1.success) setError(j1.message);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading && payments.length === 0) {
    return (
      <div className="admin-page-loading">
        <div className="admin-spinner" />
        <p>Loading payments...</p>
      </div>
    );
  }

  const s = summary || {};

  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Payments & Commission</h2>
      <p className="admin-page-subtitle">All transactions with booking-wise breakup, app commission and host payout.</p>
      {error && <div className="admin-page-error">{error}</div>}

      <div className="admin-summary-cards">
        <div className="admin-summary-card">
          <span className="admin-summary-label">Total revenue</span>
          <span className="admin-summary-value">₹{(s.totalRevenue ?? 0).toLocaleString()}</span>
        </div>
        <div className="admin-summary-card">
          <span className="admin-summary-label">App commission</span>
          <span className="admin-summary-value">₹{(s.totalCommission ?? 0).toLocaleString()}</span>
        </div>
        <div className="admin-summary-card">
          <span className="admin-summary-label">Host payout</span>
          <span className="admin-summary-value">₹{(s.totalHostPayout ?? 0).toLocaleString()}</span>
        </div>
      </div>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Guest</th>
              <th>Property</th>
              <th>Total (₹)</th>
              <th>Commission (₹)</th>
              <th>Host (₹)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p._id}>
                <td>{p.createdAt ? new Date(p.createdAt).toLocaleString() : '—'}</td>
                <td>{p.user?.name || p.user?.email || '—'}</td>
                <td>{p.property?.name || '—'}</td>
                <td>{(p.totalAmount ?? 0).toLocaleString()}</td>
                <td>{(p.commissionAmount ?? 0).toLocaleString()}</td>
                <td>{(p.hostAmount ?? 0).toLocaleString()}</td>
                <td><span className={`admin-badge status-${p.status}`}>{p.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPayments;
